import React from 'react';
import googleCalendarLogo from './google_calendar.png';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

function GoogleCalendarLogo({ ...props }) {
  const { tr } = useTranslation();
  return <img src={googleCalendarLogo} alt={tr('perform.logos.google_calendar.alt')} {...props} />;
}

export default GoogleCalendarLogo;
